<!-- <h4 class="title">Customer Details</h4> -->

<div class="cus-tab">
  <div class="pro-head">
    <div class="row fix-user" style="margin-left: 0px;margin-right:0px;">
      <div>
        <div class="ht-img" style="float: left;">
          <img src="https://www.svgimages.com/svg-image/s5/man-passportsize-silhouette-icon-256x256.png"
            alt="stack photo" class="img">
        </div>

        <div style="float: left;">
          <h2 style="font-size: 12px;margin-bottom: 0px;line-height: 20px;color: #fff;margin-top: 6px;">John Doe</h2>
          <p style="font-size: 12px;color: #d0d0d0;margin-bottom: 6px;">Acc.No: 9876543210000</p>
        </div>
      </div>
      <div class="card-box">
        <h4 class="title-f">Personal Details</h4>
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-12">
            <h5 class="form-lable">Name:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Gender:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Marital Status:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Date of Birth:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Nationality:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Tax No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">EID/Adhar:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">DL No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
             </div> -->

        </div>
      </div>
      <div class="card-box">
        <h4 class="title-f">Employement Details</h4>
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-12">
            <h5 class="form-lable">Constitution:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Industry:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Profession:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Current Organization / Business:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Designation:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">Previous Organization:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">IC / Passport No. / Businees Reg No:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-12">
            <h5 class="form-lable">SSN:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
             </div> -->

        </div>
      </div>

    </div>
  </div>
  <div class="col-md-12" style="padding-left: 260px;">
    <mat-tab-group>
      <!-- <mat-tab label="Customer Details">
      <br>
      <div class="row" style="margin-left: 0px;margin-right:0px;">
        <div class="col-md-12">
          <div class="card-box">
            <h4 class="title-f">Personal Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
              <div class="col-md-4">
                <h5 class="form-lable">Name:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Gender:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Marital Status:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Date of Birth:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Nationality:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Tax No:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">DL No:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-12 mt-20">
                    <button type="button" class="btn btn-primary">Add</button>
               </div>
      
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card-box">
            <h4 class="title-f">Employement Details</h4>
            <div class="row" style="padding: 0px 0px 23px 10px;">
              <div class="col-md-4">
                <h5 class="form-lable">Constitution:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Industry:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Profession:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Current Organization / Business:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Designation:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">Previous Organization:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-8">
                <h5 class="form-lable">IC / Passport No. / Businees Reg No:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-4">
                <h5 class="form-lable">SSN:</h5>
                <input type="text" pInputText placeholder="">
              </div>
              <div class="col-md-12 mt-20">
                    <button type="button" class="btn btn-primary">Add</button>
               </div>
      
            </div>
          </div>
        </div>
      </div>
      
  
    </mat-tab> -->
      <mat-tab label="Address Details">
        <br>
        <app-usr-addressdetails></app-usr-addressdetails>
      </mat-tab>
      <mat-tab label="Bank Details">
        <!-- <h4 class="title-f">Address Details</h4> -->
        <div class="row" style="margin-right: 0px;margin-left: 0px;margin-top: 20px;">
          <div class="col-md-12">
            <div class="card-box">
              <h4 class="title-f">Bank Details</h4>
              <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-4">
                  <h5 class="form-lable">Bank Name :</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Branch:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Account No:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Year Opened:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Status:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
                </div>

              </div>
            </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="search-hero">
                  <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                      [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
              </div>
          </div> -->
          <!--  h -->
          <!-- <div class="col-md-2 text-right">
            <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
          </div> -->
        </div>
        <br>
        <div class="doc-table">
          <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">

            <ng-template pTemplate="header">
              <tr class="thhead">
                <th>
                  Bank Name
                </th>
                <th>
                  Branch
                </th>
                <th>
                  Account Type
                </th>

                <th>
                  Account No.
                </th>
                <th>
                  Year Opened
                </th>
                <th>
                  Status
                </th>
                <th style="width: 110px;text-align:center">
                  Action
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="act">
                  <!-- <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                  <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i> -->
                </td>
              </tr>
            </ng-template>
           </p-table>  </div>

        </div>


      </mat-tab>
      <mat-tab label="Income Details">
        <div class="row" style="margin-right: 0px;margin-left: 0px; margin-top: 20px;">
          <div class="doc-table">
            <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
              [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="['type']">

              <ng-template pTemplate="header">
                <tr class="thhead">
                  <th>
                    Year
                  </th>
                  <th>
                    Income
                  </th>
                  <!-- <th>
                  Account Type 
                </th>

                <th>
                  Account No.
                </th>
                <th>
                  Year Opened 
                </th>
                <th>
                  Status
                </th>
                <th style="width: 110px;text-align:center">
                  Action
                </th> -->
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow">
                  <td></td>
                  <td></td>
                  <!-- <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="act">
                  <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                  <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                </td> -->
                </tr>
              </ng-template>
             </p-table>  </div>

          </div>
        </div>
      </mat-tab>
      <mat-tab label="Liability Details">
        <div class="row" style="margin-right: 0px;margin-left: 0px; margin-top: 20px;">
          <div class="doc-table">
            <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
              [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="['type']">

              <ng-template pTemplate="header">
                <tr class="thhead">
                  <th>
                    Liability Description
                  </th>
                  <th>
                    Financier Details
                  </th>
                  <th>
                    Liability Type
                  </th>
                  <!-- <th>
                  Account Type 
                </th>

                <th>
                  Account No.
                </th>
                <th>
                  Year Opened 
                </th>
                <th>
                  Status
                </th>
                <th style="width: 110px;text-align:center">
                  Action
                </th> -->
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow">
                  <td></td>
                  <td></td>
                  <td></td>
                  <!-- <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="act">
                  <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                  <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                </td> -->
                </tr>
              </ng-template>
             </p-table>  </div>

          </div>
        </div>
      </mat-tab>
      <mat-tab label="Esisting Asset Details"> 
          <!-- <h4 class="title-f">Address Details</h4> -->
          <div class="row" style="margin-right: 0px;margin-left: 0px;margin-top: 20px;">
            <div class="col-md-12">
              <div class="card-box">
                <h4 class="title-f">Esisting Asset Details</h4>
                <div class="row" style="padding: 0px 0px 23px 10px;">
                  <div class="col-md-4">
                    <h5 class="form-lable">Asset Description:</h5>
                    <input type="text" pInputText placeholder="">
                  </div>
                  <div class="col-md-4">
                    <h5 class="form-lable">Asset Cost:</h5>
                    <input type="text" pInputText placeholder="">
                  </div>
                  <div class="col-md-4">
                    <h5 class="form-lable">Additional Information:</h5>
                    <input type="text" pInputText placeholder="">
                  </div>
                  <div class="col-md-4 mt-20">
                    <button type="button" class="btn btn-primary">Add</button>
                  </div>
  
                </div>
              </div>
            </div>
            <!-- <div class="col-md-4">
                <div class="search-hero">
                    <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                        [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
                </div>
            </div> -->
            <!--  h -->
            <!-- <div class="col-md-2 text-right">
              <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
            </div> -->
          </div>
          <br>
          <div class="doc-table">
            <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
              [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="['type']">
  
              <ng-template pTemplate="header">
                <tr class="thhead">
                  <th>
                    Asset Description 
                  </th>
                  <th>
                    Asset Cost 
                  </th>
                  <th>
                    Additional Information
                  </th>
                  <!-- <th style="width: 110px;text-align:center">
                    Action
                  </th> -->
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow">
                  <td></td>
                  <td></td>
                  <td></td>
                  <!-- <td></td>
                  <td></td>
                  <td></td>
                  <td class="act">
                    <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                    <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                  </td> -->
                </tr>
              </ng-template>
             </p-table>  </div>
  
          </div>
  
  
      </mat-tab>
      <mat-tab label="Credit Card Details"> 
         <!-- <h4 class="title-f">Address Details</h4> -->
         <div class="row" style="margin-right: 0px;margin-left: 0px;margin-top: 20px;">
          <div class="col-md-12">
            <div class="card-box">
              <h4 class="title-f">Credit Card Details</h4>
              <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-4">
                  <h5 class="form-lable">Card Number:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Card Type:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Card Category:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Financier Type:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Amount Due:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Valid Till:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Card Limit:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4">
                  <h5 class="form-lable">Status:</h5>
                  <input type="text" pInputText placeholder="">
                </div>
                <div class="col-md-4 mt-20">
                  <button type="button" class="btn btn-primary">Add</button>
                </div>

              </div>
            </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="search-hero">
                  <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                      [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
              </div>
          </div> -->
          <!--  h -->
          <!-- <div class="col-md-2 text-right">
            <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
          </div> -->
        </div>
        <br>
        <div class="doc-table">
          <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">

            <ng-template pTemplate="header">
              <tr class="thhead">
                <th>
                  Card Number 
                </th>
                <th>
                  Card Type 
                </th>
                <th>
                  Card Category
                </th>
                <th>
                  Member Since 
                </th>
                <th>
                  Amount Due 
                </th>
                <th>
                  Valid Till 
                </th>
                <th>
                  Card Limit 
                </th>
                <th>
                  Status
                </th>
                <!-- <th style="width: 110px;text-align:center">
                  Action
                </th> -->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow">
                <td></td>
                <td></td>
                <td></td>
                <!-- <td></td>
                <td></td>
                <td></td>
                <td class="act">
                  <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                  <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                </td> -->
              </tr>
            </ng-template>
           </p-table>  </div>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<!-- <div class="doc-table">
  <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    <ng-template pTemplate="header">
      <tr style="text-align: center;">
        <td> <button class="btn btn-primary mr-0" style="width: 100%;" (click)="show1()">Address Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Bank Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Income Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Liability Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Esisting Asset Details</button> </td>
        <td> <button class="btn btn-primary mr-0" style="width: 100%;">Credit Card Details</button> </td>
      </tr>
    </ng-template>
   </p-table>  </div>
</div> -->